export enum LoginStatus {
  NONE = "NONE",
  INIT = "INIT",
  LOGIN = "LOGIN",
  ERROR = "ERROR",
  LOGOUT = "LOGOUT",
  REGISTRATION = "REGISTRATION",
  AGREEMENT = "AGREEMENT"
}
